// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import { shareLinkStyles } from "@bg/Overrides/Widgets/ProductDetails/ProductDetailsShareLink";

shareLinkStyles.link = {
    link: linkIconStyleGenerator(
        "Share",
        "13px",
        14,
        "margin-right: 20px; color: #131313 !important;",
        "color: #9C822F;",
    ),
};
shareLinkStyles.printLink = linkIconStyleGenerator("Print", "13px", 14, "color: #131313 !important;", "fill: #9C822F;");
